import React from 'react';
import HeroCarousel from '../components/HeroCarousel';
import ServiciosDestacados from '../components/ServiciosDestacados';
import ProgramasSociales from '../components/ProgramasSociales';
import BannersRotativos from '../components/BannersRotativos';
import UltimasNoticias from '../components/UltimasNoticias';

const Home = () => {
  return (
    <div className="min-h-screen">
      <HeroCarousel />
      <ServiciosDestacados />
      <ProgramasSociales />
      <BannersRotativos />
      <UltimasNoticias />
    </div>
  );
};

export default Home;